// PortalRoot.tsx
import React from "react";
import ReactDOM from "react-dom";
import styles from "./PortalRoot.module.css";
import { OverlayOpacity, PORTAL_ZINDEX } from "./types";

interface PortalRootProps {
    overlayOpacity?: OverlayOpacity;
    baseZIndex?: number;
    children?: React.ReactNode;
}

const PortalRoot: React.FC<PortalRootProps> = ({ overlayOpacity = OverlayOpacity.COVERED, baseZIndex = 0, children }) => {
    let opacityStyle = ''
    switch (overlayOpacity) {
        case OverlayOpacity.TRANSPARENT:
            opacityStyle = styles.transparentRoot;
            break;
        case OverlayOpacity.GRAY:
            opacityStyle = styles.opaqueRoot;
            break;
        case OverlayOpacity.BLACK:
            opacityStyle = styles.blackRoot;
            break;
    }

    // Append this to the body so it fully covers your existing #root
    return ReactDOM.createPortal(
        <div
            className={`${styles.portalRoot} ${opacityStyle}`}
            style={{ zIndex: baseZIndex + PORTAL_ZINDEX }}>
            {children}
        </div>,
        document.body
    );
};

export default PortalRoot;
